export const IS_BETA_CANDIDATE_SETTING = 'isBetaCandidate'
